var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 256C198.692 256 256 198.692 256 128C256 57.3076 198.692 0 128 0C57.3076 0 0 57.3076 0 128C0 198.692 57.3076 256 128 256Z",
    fill: "#00EF8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.064 108.032H147.968V144.128H184.064V108.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.872 157.696C111.872 165.12 105.728 171.264 98.3039 171.264C90.8799 171.264 84.7359 165.12 84.7359 157.696C84.7359 150.272 90.8799 144.128 98.3039 144.128H111.872V108.032H98.3039C70.9119 108.032 48.6399 130.304 48.6399 157.696C48.6399 185.088 70.9119 207.36 98.3039 207.36C125.696 207.36 147.968 185.088 147.968 157.696V144.128H111.872V157.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.536 89.856H202.24V53.76H161.536C134.144 53.76 111.872 76.032 111.872 103.424V108.032H147.968V103.424C147.968 96 154.112 89.856 161.536 89.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.968 108.032H111.872V144.128H147.968V108.032Z",
    fill: "#16FF99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlow);
export default __webpack_public_path__ + "static/media/flow.5fc5ba97947634753c427a1124c39946.svg";
export { ForwardRef as ReactComponent };